<template>
  <default-layout>
    <v-card class="c-card-wrapper" elevation="2">
      <div class="header-card-wrapper">
        <v-card-title>Profile</v-card-title>
      </div>
      <div class="body-card-wrapper body-profile">
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Email"
              outlined
              dense
              hide-details
              class="c-text-field"
              value="Test"
              disabled
              v-model="email"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Name"
              outlined
              dense
              hide-details
              class="c-text-field"
              v-model="name"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div style="display: flex; justify-content: flex-end">
              <v-btn class="c-btn-primary" :disabled="db.name == name" @click="update"
                >Update</v-btn
              >
            </div>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Old Password"
              outlined
              dense
              hide-details
              class="c-text-field"
              v-model="oldPass"
              type="password"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="New Password"
              outlined
              type="password"
              dense
              hide-details
              class="c-text-field"
              v-model="newPass"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              type="password"
              label="Confirm Password"
              outlined
              dense
              hide-details
              class="c-text-field"
              v-model="confirmPass"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div style="display: flex; justify-content: flex-end">
              <v-btn
                class="c-btn-primary"
                :disabled="
                  !(
                    confirmPass !== '' &&
                    newPass !== '' &&
                    oldPass !== '' &&
                    confirmPass === newPass &&
                    newPass.length > 8 &&
                    newPass != oldPass
                  )
                "
                @click="changePassword"
                >Change Password</v-btn
              >
            </div>
            <div class="alert-wrapper" style="margin-top: 15px; margin-left: 0; margin-right: 0;" v-if="error !== ''">
                  <v-alert dense outlined type="error">
                    <strong>{{error}}</strong>
                  </v-alert>
                </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </default-layout>
</template>

<script>
import me from "@/api/me";
import updatePassword from '@/api/changePassword'
import updateProfile from '@/api/updateProfile';
import DefaultLayout from "./layout/DefaultLayout.vue";
export default {
  components: { DefaultLayout },
  data() {
    return {
      name: "",
      email: "",
      db: {
        name: "",
        email: "",
      },
      newPass: "",
      confirmPass: "",
      oldPass: "",
      error: '',
      loading: false
    };
  },
  async created() {
    let data = await me();
    this.email = this.db.email = data.data.email;
    this.name = this.db.name = data.data.name;
  },
  methods:{
    async changePassword(){
      this.error = ''
      this.loading = true;
      const res = await updatePassword(this.oldPass, this.newPass, this.confirmPass);
      if(res == null || res.data.error ){
        this.error = "Change password Failed";
      }
      this.loading = false
    },
    async update(){
      this.error = ''
      this.loading = true;
      const res = await updateProfile(this.name);
      if(res == null ||res.data.error){
        this.error = "Failed update profile";
      }
      this.loading = false
    }
  }
};
</script>

<style lang="scss" scoped>
.body-profile {
  padding: 0 20px;
  margin-top: 25px;
}
</style>
